import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

export default function TemplateCard({
  title,
  subtitle,
  description,
  count,
  colors = ["#000"],
  icon,
  onClick,
  isDarkTheme,
  buttonText,
  buttonAction,
}) {
  const { t } = useTranslation("coaching-portal");
  const isGradient = colors.length === 2;

  const backgroundStyle = isGradient
    ? {
        background: `linear-gradient(to bottom right, ${colors[0]}, ${colors[1]})`,
      }
    : {
        background: colors[0],
      };

  return (
    <div className="template-card-background-outline">
      <div
        onClick={onClick}
        className="relative w-[344px] h-[311px] rounded-[1.75rem] overflow-hidden"
        style={backgroundStyle}
      >
        {/* Top Icon */}
        <div className="flex justify-center pt-[40px] pb-[96px]">{icon}</div>

        {/* Folder Shape - scaled slightly so it fully covers rounded corners (clipped by parent overflow-hidden) */}
        <div
          className="absolute bottom-0 left-0 w-full origin-bottom"
          style={{ transform: "scale(1.03)" }}
        >
          <SvgIcon
            src={`${isDarkTheme ? "/img/new-icons/folder-template-dark.svg" : "/img/new-icons/folder-template-light.svg"}`}
            noFilterOnLight={true}
          />
        </div>

        {/* Content */}
        <div className="absolute bottom-0 left-0 w-full h-[210px] px-6 pt-8 pb-4 flex flex-col">
          <div className="flex-1 min-h-0">
            <h2 className="text-lg font-semibold ">{title}</h2>
            <p className="p4">{subtitle}</p>
            <p className="p5 mt-4">{description}</p>
          </div>
          <div className="flex items-center justify-between shrink-0">
            {!!count && (
              <>
                <div>
                  <span className="text-5xl font-light">
                    {String(count).padStart(2, "0")}
                  </span>
                  <span className="ml-2 text-sm uppercase opacity-70">
                    {count > 1
                      ? t("allTemplates.templateCard.templates")
                      : t("allTemplates.templateCard.template")}
                  </span>
                </div>

                <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center backdrop-blur-md group-hover:bg-white/20 transition">
                  <SvgIcon src="/img/new-icons/arrow-forward.svg" />
                </div>
              </>
            )}
            {!count && (
              <button
                type="button"
                data-button-type="secondary"
                onClick={buttonAction}
                className="w-full"
              >
                <SvgIcon src="/img/new-icons/add.svg" />
                {buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
